import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)
import {Line} from "react-chartjs-2";
import { useMemo } from 'react';

const LineChart = ({chartData, itemKey, theme, width, height}) => {
  const options = {
    responsive: false,
    maintainAspectRatio: false,
    animation: {
      duration: 0
    },
    plugins:{
      title: {
        display: false
      },
      legend: {
        display: false
      },
      tooltips: {
        enabled: false
      },
      grid: {
        display: false
      }
    },
    scales: {
      x:
        {
          display:false,
          ticks: {
            display: false
          },
          grid: {
            display: false
          }
        },
      y:
        {
          display:false,
          ticks: {
            display: false
          },
          grid: {
            display: false
          }
        }
    }
  };
  const themeColor = {
    "up-color": ["#45BF59", "rgba(69, 191, 89,0.2)", "rgba(69, 191, 89,0.05)", "rgba(0, 0, 0,0)"],
    "down-color": ["#D94F4F", "rgba(217, 79, 79,0.2)", "rgba(217, 79, 79,0.05)", "rgba(0, 0, 0,0)"]
  }
  const gradient = () => {
    const canvas = document.createElement("canvas");
    const gradient = canvas.getContext("2d").createLinearGradient(0, -25, 0, 80);
    gradient.addColorStop(0, (themeColor[theme] || themeColor["up-color"])[0]);
    gradient.addColorStop(0.3, (themeColor[theme] || themeColor["up-color"])[1]);
    gradient.addColorStop(0.6, (themeColor[theme] || themeColor["up-color"])[2]);
    gradient.addColorStop(1, (themeColor[theme] || themeColor["up-color"])[3]);
    return gradient;
  }
  const handleChartData = (data)=>{
    if(!data)return [];
    const resData = [];
    if (data.length) data.map((item) => resData.unshift(item.c)); //K线收盘价
    if (resData.length == 1) return [resData[0], resData[0]];
    return resData;
  }
  const resData = handleChartData(chartData);
  const data = () => {
    return {
      labels:resData,
      datasets: [
        {
          label:itemKey,
          fill:'origin',
          lineTension:0.4,
          backgroundColor: gradient,
          borderColor: (themeColor[theme] || themeColor["up-color"])[0],
          pointRadius: 0,
          pointHoverBorderWidth: 0,
          pointHoverRadius: 0,
          borderWidth: 2,
          data: resData,
        },
      ],
    };
  }
  return useMemo(()=>{
    return <Line data={data()} key={itemKey} options={options} redraw={true} width={width || 200} height={height || 50}/>;
  },[JSON.stringify(resData)]);
}
export default LineChart;